import PendingAppointmentsComponent from './PendingAppointmentsComponent';
export default PendingAppointmentsComponent;
